import { AlertTriangle } from 'lucide-react';
import type { JSX } from 'react';
import { cn } from '@/lib/cn.js';
import { Button } from './button.js';

/**
 * Erreur technique — `02` §0 : « message en français courant + détail
 * technique repliable ; jamais de page blanche. » `detail` (la plupart du
 * temps `ApiError.detail`) n'est affiché que s'il est fourni : en production
 * l'API ne le renvoie pas (`04` §6, `exposeDetail`).
 */
export interface ErrorStateProps {
  message: string;
  detail?: string | undefined;
  onRetry?: (() => void) | undefined;
  className?: string | undefined;
}

export function ErrorState({ message, detail, onRetry, className }: ErrorStateProps): JSX.Element {
  return (
    <div
      role="alert"
      className={cn(
        'flex flex-col items-center gap-3 rounded-lg border border-border bg-card px-6 py-10 text-center',
        className,
      )}
    >
      <div className="flex size-10 items-center justify-center rounded-lg bg-status-red-bg text-status-red-fg">
        <AlertTriangle className="size-5" aria-hidden="true" />
      </div>
      <p className="max-w-md text-sm font-medium text-foreground">{message}</p>
      {detail ? (
        <details className="w-full max-w-xl text-left">
          <summary className="cursor-pointer text-center text-xs text-muted-foreground hover:text-foreground">
            Détail technique
          </summary>
          <pre className="mt-2 overflow-auto whitespace-pre-wrap break-words rounded-md border border-border bg-muted p-3 text-left font-mono text-xs text-muted-foreground">
            {detail}
          </pre>
        </details>
      ) : null}
      {onRetry ? (
        <Button variant="outline" size="sm" onClick={onRetry}>
          Réessayer
        </Button>
      ) : null}
    </div>
  );
}
